// extracted by mini-css-extract-plugin
export default {"side":"SideBar_side__fboVQ"};